<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <img :src="activity.image" alt class="w-100" />
            <div class="py-3">
              <h1>{{ activity.title }}</h1>
              <p>{{ activity.subtitle }}</p>
              <router-link to="/member/news/activity-list" class="btn btn-primary btn-block">回到活動訊息</router-link>
            </div>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import db from "../../api/db";
import MemberLayout from "../../components/member/MemberLayout";
export default {
  name: "ActivityDetailScreen",
  components: {
    MemberLayout
  },
  data() {
    return {
      activity: {}
    };
  },
  mounted() {
    const vm = this;
    const activityId = vm.$route.params.activityId;
    db.doc(`activities/${activityId}`)
      .get()
      .then(doc => {
        const activity = doc.data();
        activity.id = doc.id;
        vm.activity = activity;
      })
      .catch(err => {
        console.log("err", err);
      });
  }
};
</script>
<style scoped>
</style>